import { render, staticRenderFns } from "./browserType.vue?vue&type=template&id=904313de&"
import script from "./browserType.vue?vue&type=script&lang=js&"
export * from "./browserType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports